////////LIBRARY/////////
import React, { useEffect, useState, useRef } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { cloneDeep, find, map, keys, get, isUndefined, isEmpty, includes, reject } from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'
///////COMPONENTS///////
import useListSort from '../Table/hooks/UseListSort'
import Tooltip from '../Tooltip/Tooltip'
import UseWindowResize from '../../hooks/UseWindowResize'
/////////ASSETS/////////
import EditIcon from '../../assets/icones/global/edit-white.svg'
import DeleteIcon from '../../assets/icones/global/trash-white.svg'
import RemovableIcon from '../../assets/icones/global/close-white.svg'
import ArrowUp from '../../assets/icones/global/arrow-up-big.svg'
import ArrowDown from '../../assets/icones/global/arrow-down-big.svg'
import ArrowUpGrey from '../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowDownGrey from '../../assets/icones/global/arrow-down-big-grey.svg'

/////////STYLED/////////
const ListEditableWrapper = styled.div`
	position: relative;
`
const ListEditableItems = styled.div`
	position: relative;
	display:flex;
	flex-direction:column;
	overflow-y: scroll;
	height: ${(props) => `${props.sizeHeightActions ? props.sizeHeight - props.sizeHeightActions : props.sizeHeight}px`};
	&::-webkit-scrollbar {
		width: 15px;
		background-color:rgba(0,0,0,.15);
		height: 50px;
	}
	  &::-webkit-scrollbar-thumb {
		  background: #4D4F5C; 
	}
	  &::-webkit-scrollbar-thumb:active {
		background rgba(77, 79, 92, 0.7); 
	}
	  &::-webkit-scrollbar-button:vertical:decrement:single-button {
		  background: no-repeat url(${ArrowUp}) center;
		  height:15px;
	}
	  &::-webkit-scrollbar-button:vertical:increment:single-button {
		  background: no-repeat url(${ArrowDown}) center;
		  height:15px;
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height:15px;
  }
	&::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height:15px;
  }
	  /* scrollbar styling standard version */
	  & {
		scrollbar-color: #4D4F5C #E5E5E5;
		scrollbar-width: thin;
	}
`
const ListEditableItem = styled.div`
	padding: 15px 20px;
	border: ${(props) => (props.lineselected ? 'none' : `1px solid ${props.theme.colors.listNav.border}`)};
	margin: 2px 0px;
	display: flex;
	align-items: center;
	:first-child {
		margin-top: 0px;
	}
	background-color: ${(props) => (props.lineselected ? props.theme.colors.listNav.hover : props.theme.colors.white)};
	color: ${(props) => (props.lineselected ? props.theme.colors.white : props.theme.text.colors.primary)};
	cursor: pointer;
	display: ${(props) => ((props.type === 'removable' && props.lineselected) || props.type !== 'removable' ? 'inherit' : 'none')};
`
const ListEditableInput = styled.input`
	margin: 0px 35px 0px 0px;
`
const ListEditableLabel = styled.div`
	margin: ${(props) => {
		if (isUndefined(props.usingMarker)) {
			return '0px 35px 0px 0px'
		} else {
			return props.usingMarker ? '0px 35px 0px 0px' : '0px 35px 0px 40px'
		}
	}};
`
const ListEditableAdditionalLabel = styled.div`
	margin-right: 0px;
	margin-left: auto;
`
const ListEdtiableItemActions = styled.div`
	position: relative;
	margin-right: 0px;
	margin-left: auto;
	display: flex;
`
const ListEdtiableItemActionsEdit = styled.div`
	margin: 0px 7px;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url(${EditIcon});
	background-size: contain;
	width: 16px;
	height: 16px;
	cursor: pointer;
`
const ListEdtiableItemActionsDelete = styled.div`
	margin: 0px 7px;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	background-image: url(${DeleteIcon});
	width: 16px;
	height: 16px;
	cursor: pointer;
`
const ListEditableMarker = styled.img`
	margin-right: 28px;
`

const ListEditableRemovable = styled.img`
	width: 10px;
	height: 10px;
	cursor: pointer;
	margin-right: 35px;
`
/////////STYLED/////////

const ListEditable = ({
	inputColumns,
	inputData,
	type,
	sortColumnName,
	sortDir,
	editMethod,
	deleteMethod,
	listSelected,
	sizeHeightActions,
	currentListSelected,
	removableList,
	fixedBaseHeight,
	keepSelected = false,
}) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [tableData, trigger, setTrigger, setTableData, sortDirection, setSortDirection] = useListSort(inputColumns, inputData)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSortTableHeader = (headerName) => {
		setTrigger({
			data: headerName,
			trigger: trigger + 1,
		})
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setSortDirection(sortDir)
		setTableData(cloneDeep(inputData))
		handleSortTableHeader(sortColumnName)
	}, [inputData])

	useEffect(() => {
		setSortDirection(sortDir)
		handleSortTableHeader(sortColumnName)
	}, [sortColumnName, sortDir])

	const [rowsSelected, setRowsSelected] = useState(!isUndefined(removableList) ? removableList : [])

	// clear selected values on table data refresh / reset
	useEffect(() => {
		if (!isEmpty(rowsSelected) && isEmpty(currentListSelected)) {
			setRowsSelected(!isUndefined(removableList) ? removableList : keepSelected ? rowsSelected : [])
		}
	}, [tableData])

	useEffect(() => {
		setRowsSelected(!isUndefined(removableList) ? removableList : [])
	}, [removableList])
	const handleRowSelected = (selectedId, e) => {
		if (!e.target.classList.contains('lineactions')) {
			if (type === 'radio') {
				setRowsSelected([selectedId])
			}
			if (type === 'checkbox') {
				let newCheckedList = cloneDeep(rowsSelected)
				// Check if id is in list
				if (includes(newCheckedList, selectedId)) {
					newCheckedList = reject(newCheckedList, (o) => {
						return o === selectedId
					})
				} else {
					newCheckedList.push(selectedId)
				}
				setRowsSelected(newCheckedList)
			}
		}
		// TODO : handle removable mod
		// => We cannot add elements to list
		if (type === 'removable') {
			let newCheckedList = cloneDeep(rowsSelected)
			newCheckedList = reject(newCheckedList, (o) => {
				return o === selectedId
			})
			setRowsSelected(newCheckedList)
		}
	}

	useEffect(() => {
		/*!isEmpty(rowsSelected) && */ listSelected(rowsSelected)
	}, [rowsSelected])

	useEffect(() => {
		if (!isEmpty(inputData)) {
			refListRoles.current = inputData
		} else {
			if (!isUndefined(refListRoles.current)) {
				setRowsSelected(!isUndefined(removableList) ? removableList : [])
			}
		}
	}, [inputData])

	// Prechecking a list on loading only
	useEffect(() => {
		if (tableData?.length > 0 && isEmpty(rowsSelected) && !isUndefined(currentListSelected)) {
			setRowsSelected(currentListSelected)
		}
	}, [tableData, currentListSelected])

	const refListRoles = useRef()

	const [dimensions] = UseWindowResize()

	let columnForId

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ListEditableWrapper>
			<ListEditableItems sizeHeight={fixedBaseHeight ? fixedBaseHeight : dimensions.height - 80} sizeHeightActions={sizeHeightActions}>
				{
					// We get what column is used for id, so we can apply an onClick to the entire line
					map(inputColumns, (column, _columnid) => {
						if (column.isRadioValue || column.isRemovableValue) {
							columnForId = column.dataHook
						}
					})
				}
				{tableData &&
					map(tableData, (row, _id) => {
						let isRowSelected = false
						if (rowsSelected.length > 0)
							isRowSelected = find(rowsSelected, (o) => {
								return o === row?.id
							})
								? true
								: false
						return (
							<ListEditableItem
								lineselected={rowsSelected.length > 0 && isRowSelected}
								onClick={(e) => {
									handleRowSelected(
										get(
											row,
											columnForId,
											find(rowsSelected, (o) => o === get(row, columnForId))
										),
										e
									)
								}}
								type={type}
							>
								{
									// Map with columns
									map(inputColumns, (column, _columnid) => {
										let row_name
										let ret
										let add_row_name
										if (column.isRemovableValue) {
											row_name = find(keys(row), (o) => o === column.dataHook)
											ret = (
												<ListEditableRemovable
													src={RemovableIcon}
													onClick={(e) => {
														handleRowSelected(
															get(
																row,
																row_name,
																find(rowsSelected, (o) => o === get(row, row_name))
															),
															e
														)
													}}
												/>
											)
										}
										if (column.isRadioValue) {
											row_name = find(keys(row), (o) => o === column.dataHook)
											// checked property is only use for debug => when we delete a row, somehow the "next" radio is checked...
											ret = (
												<ListEditableInput
													name="id"
													type={type}
													value={get(row, row_name)}
													checked={find(rowsSelected, (o) => o === get(row, row_name))}
												></ListEditableInput>
											)
										}
										if (column.hasMarker) {
											row_name = find(keys(row), (o) => o === column.dataHook)
											if (get(row, row_name)) {
												ret = isRowSelected ? ( //test if list is from tag menu or role menu
													<Tooltip
														translationsKey={
															!isUndefined(row.level)
																? 'tooltip__admin__roleManagement__privateRole'
																: 'tooltip__admin__tagManagement__typeOfTag'
														}
														tooltipId={!isUndefined(row.level) ? 'rolesListIcon' : 'tagsListIcon'}
													>
														<ListEditableMarker src={column.iconSelected} />
													</Tooltip>
												) : (
													<Tooltip
														translationsKey={
															!isUndefined(row.level)
																? 'tooltip__admin__roleManagement__privateRole'
																: 'tooltip__admin__tagManagement__typeOfTag'
														}
														tooltipId={!isUndefined(row.level) ? 'rolesListIcon' : 'tagsListIcon'}
													>
														<ListEditableMarker src={column.icon} />
													</Tooltip>
												)
											} else {
												ret = null
											}
										}
										if (column.isLabel) {
											row_name = find(keys(row), (o) => o === column.dataHook)
											add_row_name = find(keys(row), (o) => o === column.additionalLabelName)
											const usingMarker = find(keys(row), (o) => o === column.usingMarker)
											ret = column.alreadyTranslated ? (
												<ListEditableLabel usingMarker={get(row, usingMarker)}>
													{get(row, row_name)}
													{!isUndefined(add_row_name) ? ` - ${get(row, add_row_name)}` : ''}
												</ListEditableLabel>
											) : (
												<ListEditableLabel usingMarker={column.usingMarker}>
													{translations[get(row, row_name)]}
													{!isUndefined(add_row_name) ? `${translations[get(row, add_row_name)]}` : ''}
												</ListEditableLabel>
											)
										}

										// In radio mode, actions will replace additonnal label
										if (column.isAdditionalLabel && type === 'radio') {
											row_name = find(keys(row), (o) => o === column.dataHook)
											// If no line is selected
											ret =
												rowsSelected.length === 0 || !isRowSelected ? (
													<ListEditableAdditionalLabel>Niveau {get(row, row_name)}</ListEditableAdditionalLabel>
												) : (
													<ListEdtiableItemActions>
														{/*We expect property checkers to be named like below*/}
														{row.canBeModify && (
															<Tooltip tooltipId={'listUpdateRadio'} translationsKey={'tooltip__admin__global__update'}>
																<ListEdtiableItemActionsEdit onClick={() => editMethod(row)} />
															</Tooltip>
														)}
														{row.canBeDelete && (
															<Tooltip tooltipId={'listDeleteRadio'} translationsKey={'tooltip__admin__global__delete'}>
																<ListEdtiableItemActionsDelete onClick={() => deleteMethod(row)} />
															</Tooltip>
														)}
													</ListEdtiableItemActions>
												)
										}

										if (type === 'checkbox' && column.isActions) {
											row_name = find(keys(row), (o) => o === column.dataHook)
											// If no line is selected
											ret = isRowSelected && (
												<ListEdtiableItemActions>
													{/*We expect property checkers to be named like below*/}
													{get(row, row_name) && (
														<Tooltip tooltipId={'listUpdateCheckbox'} translationsKey={'tooltip__admin__global__update'}>
															<ListEdtiableItemActionsEdit className="lineactions" onClick={() => editMethod(row)} />
														</Tooltip>
													)}
													{get(row, row_name) && (
														<Tooltip tooltipId={'listDeleteCheckbox'} translationsKey={'tooltip__admin__global__delete'}>
															<ListEdtiableItemActionsDelete
																className="lineactions"
																onClick={() => deleteMethod(row)}
															/>
														</Tooltip>
													)}
												</ListEdtiableItemActions>
											)
										}
										return ret
									})
								}
							</ListEditableItem>
						)
					})}
			</ListEditableItems>
		</ListEditableWrapper>
	)
}

ListEditable.propTypes = {
	inputColumns: PropTypes.array.isRequired,
	inputData: PropTypes.array,
	inputConfig: PropTypes.object.isRequired,
	keepSelected: PropTypes.bool,
}
ListEditable.defaultPropTypes = {
	inputColumns: [],
	inputData: [],
	inputConfig: {},
	keepSelected: false,
}

export default ListEditable
